export default "__VITE_ASSET__BN2iG84x__"